import { render, staticRenderFns } from "./CBProposalInsureds.vue?vue&type=template&id=3a0a73cb"
import script from "./CBProposalInsureds.vue?vue&type=script&lang=js"
export * from "./CBProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports